export function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" +
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
      "((\\d{1,3}\\.){3}\\d{1,3}))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return !!pattern.test(str);
}

/**
 * Function to truncate the text (add "...") if the string is bigger than the desired limit
 * @param {*} string
 * @param {*} limit
 * @returns
 */
export function truncateText(string = "", limit = 40) {
  if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
}

/**
 * Function to truncate the text (add "..." in the middle) if the string is bigger than the desired limit,
 * example of the return:com.mystrengthboo...qwegtyhiiktce.txt
 * @param {*} string
 * @param {*} limit
 * @returns
 */
export function truncateVideoText(string = "", limit = 23) {
  if (string.length > limit) {
    return (
      string.substring(0, 10) + "..." + string.substring(string.length - 10)
    );
  } else {
    return string;
  }
}

/**
 * Function to capitalize the first letter of a string
 * @param {*} val
 * @returns
 */
export const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};
